import { RouterProvider } from 'react-router-dom';
import { Suspense } from 'react';
import { SimpleToaster } from "@/components/ui/SimpleToaster";
import TitleManager from "@/components/TitleManager";
import { ToastProvider } from "@/components/ui/toast";
import { router } from '@/router';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import '@/i18n';

function App() {
  return (
    <ErrorBoundary>
      <TitleManager />
      <Suspense fallback={
        <div className="flex h-screen w-full items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
        </div>
      }>
        <RouterProvider router={router} />
      </Suspense>
      <ToastProvider>
        <SimpleToaster />
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
